<template>
  <div class="new-pager-main" v-if="total > 0 && total > pageSize">
    <el-pagination
      prev-text=""
      next-text=""
      background
      layout="prev, pager, next"
      :current-page="currentPage"
      :total="total"
      :page-size="pageSize"
      @prev-click="$emit('prev-click')"
      @next-click="$emit('next-click')"
      @current-change="currentChange"
      />
  </div>
</template>
<script>
export default {
  name: 'pager',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: Number
  },
  methods: {
    currentChange(page) {
      console.log("sssss")
      this.$emit('current-change', page)
      window.scrollTo(0,0)
    }
  }
}
</script>
<style lang="scss" scoped>
  .pager-main {
    margin: 20px 0;
    text-align: center;
  }
</style>
<style lang="scss">
.new-pager-main {
  display: flex;
  justify-content: center;
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #FF6644;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background: #fff;
    border-radius: 6px;
  }
}
</style>
